import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface LangRouteProps {
  lang: "de" | "en";
  children: React.ReactNode;
}

const LangRoute: React.FC<LangRouteProps> = ({ lang, children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return <>{children}</>;
};

export default LangRoute;
